import { nanoid } from "nanoid";
import { AuthClient } from "../../../repository/auth";
const getHeaders = () => {
    const headers = {
        "X-Device-Type": "WEB",
    };
    const token = AuthClient.tokens.accessToken;
    if (token) {
        headers["X-Auth-Token"] = token;
    }
    //TODO: вот тут плохо используется localStorage
    if (localStorage.getItem("deviceToken")) {
        headers["X-Device-Token"] = localStorage.getItem("deviceToken");
    }
    else {
        const deviceToken = nanoid();
        headers["X-Device-Token"] = deviceToken;
    }
    return { common: Object.assign({}, headers) };
};
export default getHeaders;
//# sourceMappingURL=getHeaders.js.map